import Select, { OptionProps } from '@storeblocks/select';
import { type ChangeEvent, type FC, useState } from 'react';

interface Props {
  label: string;
  options: OptionProps[];
  onChange: (query: string) => void;
  id?: string;
}

export const SelectSearch: FC<Props> = ({
  label,
  options,
  onChange,
  id = 'search-by-option',
}: Props) => {
  const [selectedValue, setSelectedValue] = useState('');

  const onSelectChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    setSelectedValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <Select
      name="search"
      id={id}
      label={label}
      value={selectedValue}
      options={options}
      onChange={onSelectChange}
      fluid
    />
  );
};
